export default __webpack_public_path__ + "static/media/07.98e67f35.jpg";